import { render } from "./UserSideMenu.vue?vue&type=template&id=033f7aa4&scoped=true"
import script from "./UserSideMenu.vue?vue&type=script&lang=js"
export * from "./UserSideMenu.vue?vue&type=script&lang=js"

import "./UserSideMenu.vue?vue&type=style&index=0&id=033f7aa4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033f7aa4"]])

export default __exports__